import { render, staticRenderFns } from "./PlayingDetails.vue?vue&type=template&id=7f5df0a4&scoped=true"
import script from "./PlayingDetails.vue?vue&type=script&lang=js"
export * from "./PlayingDetails.vue?vue&type=script&lang=js"
import style0 from "./PlayingDetails.vue?vue&type=style&index=0&id=7f5df0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5df0a4",
  null
  
)

export default component.exports